module.exports = __webpack_public_path__ + "static/media/face-outline-guide.bc2d3b33.svg";